import React from 'react';
import { useFormikContext } from 'formik';

/* ------------------------------------------------------------------ */
/* MatrixPreview                                                        */
/* Renders the matrix as a table with radio buttons for each cell.    */
/* Answer saved as: answer_text = "row_pos:col_pos" per row           */
/* e.g. "1:2,2:1,3:3" — each row:col pair separated by comma         */
/* ------------------------------------------------------------------ */
const MatrixPreview = ({ question, fieldName, sendSurvey, outOfDate }) => {
  const { setFieldValue, values } = useFormikContext();

  const choices = question.questionChoicesAttributes || [];
  const rows = choices.filter(c => c.kind === 'row').sort((a, b) => a.position - b.position);
  const cols = choices.filter(c => c.kind === 'column').sort((a, b) => a.position - b.position);

  const disabled = !sendSurvey || outOfDate;

  /* Parse current answer_text into a map: rowPosition -> colPosition */
  const currentAnswerText =
    values?.employeeSurvey?.employeeQuestionChoicesAttributes?.find?.(eqc => eqc?.questionId === question.id)
      ?.answerText || '';

  const parseAnswer = text => {
    const map = {};
    if (!text) return map;
    text.split(',').forEach(pair => {
      const [r, c] = pair.split(':');
      if (r && c) map[r] = c;
    });
    return map;
  };

  const buildAnswer = map =>
    Object.entries(map)
      .map(([r, c]) => `${r}:${c}`)
      .join(',');

  const selected = parseAnswer(currentAnswerText);

  const handleSelect = (rowPos, colPos) => {
    const updated = { ...selected, [String(rowPos)]: String(colPos) };
    setFieldValue(`${fieldName}[answerText]`, buildAnswer(updated));
  };

  return (
    <div className="mt-2 table-responsive">
      <table className="table table-bordered matrix-preview-table">
        <thead>
          <tr>
            <th className="matrix-preview-th-empty" />
            {cols.map(col => (
              <th key={col.position} className="text-center matrix-preview-th-col">
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <tr key={row.position}>
              <td className="matrix-preview-td-label">{row.label}</td>
              {cols.map(col => (
                <td key={col.position} className="text-center matrix-preview-td-radio">
                  <input
                    type="radio"
                    name={`matrix-${question.id}-row-${row.position}`}
                    disabled={disabled}
                    checked={selected[String(row.position)] === String(col.position)}
                    onChange={() => handleSelect(row.position, col.position)}
                    className="matrix-preview-radio"
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MatrixPreview;
